import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { HomeAuthResolver } from './home-auth-resolver.service';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [HomeComponent],
  imports: [SharedModule, HomeRoutingModule],
  providers: [HomeAuthResolver],
})
export class HomeModule {}
